import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import './PreviewError.scss';
function PreviewError({ fileName, t }) {
    return React.createElement("div", { className: "PreviewError" }, t('could_not_display_file', { file: fileName }));
}
export default withTranslation()(memo(PreviewError));
